import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useToast,
} from "@chakra-ui/react";
import NotificationService from "../../services/Notification";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
export const SelectNotificationModal = ({
  isOpen,
  onClose,
  category,
  ids,
  target
}: any) => {

  const token = localStorage.getItem("logged_in_user_token");
  const [data, setData] = useState([]);
  const [notificationId, setNotificationId] = useState<any>("");
  const toast = useToast();
  const navigate = useNavigate();
  const fetchData = () => {
    NotificationService.getNotification(token, 1, 1000, category)
      .then((res) => {
        setData(res.data.data);
        // onClose()
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  function getFormattedDateTime() {
    const now = DateTime.local();
    const formattedDate = now.toFormat("MM/dd/yyyy");

    const formattedTime = now.toFormat("hh:mm a");

    return {
      date: formattedDate,
      time: formattedTime,
    };
  }

  const handleSubmit = () => {
    const data = {
      notification_id: notificationId,
      application_type: "USER",
      lead_ids: ids,
      notification_status: "PENDING",
      source: "MANUAL",
      schedule_date: getFormattedDateTime().date,
      schedule_time: getFormattedDateTime().time,
      variable_values: [],
      error: [],
      target: target,
    };
    NotificationService.createNotifcationEvent(data);
    onClose();
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Notification</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Select
            name=""
            id=""
            onChange={(e) => setNotificationId(e.target.value)}
          >
            <option value="">Select Notification</option>
            {data.length > 0 ? (
              data.map((el: any) => <option value={el._id}>{el.name}</option>)
            ) : (
              <option value="" disabled>
                No data found
              </option>
            )}
          </Select>
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={handleSubmit}
          >
            Send
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
